<template>
  <b-modal
    id="webhook-viewer"
    title="Webhook"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    size="xl"
    @shown="openModal"
  >
    <div v-if="!loading" class="grid-web">
      <div class="item-grid">
        <h4>WebHook</h4>
        <b-list-group>
          <b-list-group-item
            v-for="item in postback"
            :key="item.id"
            href="#"
            @click="setJson(item)"
          >
            <div>{{ item.decoded_payload.event }}</div>
            de
            {{ item.decoded_payload.subscription.current_period_start | date }}
            até
            {{ item.decoded_payload.subscription.current_period_end | date }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <div class="item-grid">
        <h4>JSON</h4>

        <!-- <b-button
          variant="dark"
          :disabled="JSON.stringify(json) == '{}'"
          @click="reenviarWebhook(json.id)"
          >Reenviar este Webhook</b-button
        > -->
        <div>
          <JsonViewer v-if="!loadingJson" :value="json" />
          <div v-if="loadingJson" class="mt-5">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import JsonViewer from 'vue-json-viewer'
import axios from 'axios'
import Vue from 'vue'
import ReconcileSalesService from '@services/resources/ReconcileSalesService'
import ReconcileSubscriptionService from '@services/resources/ReconcileSubscriptionService'
const serviceReconcileSales = ReconcileSalesService.build()
const serviceReconcileSubscription = ReconcileSubscriptionService.build()

export default {
  components: {
    JsonViewer,
  },
  props: {
    dataWebhook: {
      type: Number,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      loadingJson: false,
      postback: {},
      json: {},
    }
  },
  methods: {
    setJson(item) {
      this.loadingJson = true
      this.json = item
      setTimeout(() => {
        this.loadingJson = false
      }, 500)
    },
    reenviarWebhook(id_postback) {
      this.loading = true
      let data = {
        id: `${this.dataWebhook}/postback/${id_postback}/resend`,
      }
      // axios
      //   .put(
      //     `https://apiadm.greenn.com.br/reconcile/pagarme/${this.type}/${data.id}/postback/${id_postback}/resend`
      //   )
      if (this.type == 'transaction') {
        serviceReconcileSales
          .update(data)
          .then((r) => {
            this.loading = false
            if (r.status == 200) {
              Vue.swal({
                title: 'Webhook reenviado com sucesso',
                type: 'success',
                showCancelButton: false,
              })
            }
            // this.reset()
          })
          .catch((error) => {
            console.log(error)
            this.loading = false
            Vue.swal({
              title: 'Erro ao reenviar o Webhook',
              type: 'error',
              showCancelButton: false,
            })
          })
      } else if (this.type == 'subscription') {
        serviceReconcileSubscription
          .update(data)
          .then((r) => {
            this.loading = false
            if (r.status == 200) {
              Vue.swal({
                title: 'Webhook reenviado com sucesso',
                type: 'success',
                showCancelButton: false,
              })
            }
            // this.reset()
          })
          .catch((error) => {
            console.log(error)
            this.loading = false
            Vue.swal({
              title: 'Erro ao reenviar o Webhook',
              type: 'error',
              showCancelButton: false,
            })
          })
      }
    },
    fetchPostBack() {
      let data = {
        id: this.dataWebhook,
      }
      // axios
      //   .get(
      //     `https://apiadm.greenn.com.br/reconcile/pagarme/${this.type}/${data.id}/postback`
      //   )
      if (this.type == 'transaction') {
        serviceReconcileSales
          .readSubEndpoints(`/${data.id}/postback`)
          .then((r) => {
            this.postback = r
            if (this.postback.length) {
              this.json = this.postback[0]
            }
            this.loading = false
          })
      } else if (this.type == 'subscription') {
        serviceReconcileSubscription
          .readSubEndpoints(`/${data.id}/postback`)
          .then((r) => {
            this.postback = r
            if (this.postback.length) {
              this.json = this.postback[0]
            }
            this.loading = false
          })
      }
    },
    reset() {
      this.postback = {}
      this.json = {}
    },
    openModal() {
      this.reset()
      this.loading = true
      this.fetchPostBack()
    },
  },
}
</script>

<style scoped lang="scss">
.grid-web {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
@media (max-width: 768px) {
  .grid-web {
    grid-template-columns: 1fr;
  }
}
.item-grid {
  max-height: 550px;
  overflow: auto;
}
.item-grid::-webkit-scrollbar {
  width: 12px;
}

.item-grid::-webkit-scrollbar-track {
  background: #f7f7f7;
}

.item-grid::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 3px solid #f7f7f7;
}
</style>